module.exports = __webpack_public_path__ + "img/logo.944b9d4b.png";